import React, { useState, useEffect } from "react";
import { graphqlUrl, endPoint } from "utils/config";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseIcon from "@material-ui/icons/Close";
import StorefrontIcon from "@material-ui/icons/Storefront";
import Warning from "@material-ui/icons/Warning";
import ArchiveIcon from "@material-ui/icons/Archive";
import BuildIcon from "@material-ui/icons/Build";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SearchIcon from "@material-ui/icons/Search";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import RefreshIcon from "@material-ui/icons/Refresh";
import AddIcon from "@material-ui/icons/Add";
import ErrorPage from "commonComponents/errorPage/ErrorPage";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import XLSX from "xlsx";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
// removed unused dropdown arrow icons
import Datetime from "react-datetime";
import MoonLoader from "react-spinners/MoonLoader";
import Files from "react-butterfiles";
import FormControl from "@material-ui/core/FormControl";
import BarLoader from "react-spinners/BarLoader";
import Modal from "commonComponents/modal/Modal";
import { css } from "@emotion/core";
import BeatLoader from "react-spinners/BeatLoader";
import Button from "components/CustomButtons/Button.js";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import SortIcon from "@material-ui/icons/Sort";
import ClearIcon from "@material-ui/icons/Clear";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import style from "shopAdminViews/orders/Orders.module.scss";
// designV2 components
import PageActionButton from "designV2/components/PageActionButton";
import MetricCard from "designV2/components/MetricCard";
import SearchField from "designV2/components/SearchField";
import FilterDropdown from "designV2/components/FilterDropdown";
import DateRangeFilter from "designV2/components/DateRangeFilter";
import NumberRangeFilter from "designV2/components/NumberRangeFilter";
import ActiveFilterChipList from "designV2/components/ActiveFilterChipList";
import TableToolbar from "designV2/components/TableToolbar";
import StatusBadge from "designV2/components/StatusBadge";
import EmptyState from "designV2/components/EmptyState";
import PaginationComponent from "designV2/components/Pagination";
import DialogShell from "designV2/components/DialogShell";
import "./products.css";

const ADD_PRODUCTS_VIA_EXCEL = gql`
  mutation addProductViaExcel($zipFile: Upload!) {
    addProductViaExcel(input: { zipFile: $zipFile }) {
      message
    }
  }
`;

const GET_PRODUCTS = gql`
  query getProductsByShopAdmin(
    $limit: Int
    $skip: Int
    $_id: ID
    $title: String
    $price: Float
    $stock: Int
    $stockSort: Int
    $priceSort: Int
    $createdAt: Date
    $createdAtSort: Int
    $shopMenu: String
    $priceFrom: Float
    $stockFrom: Int
    $createdAtFrom: Date
  ) {
    getProductsByShopAdmin(
      pagination: { limit: $limit, skip: $skip }
      filters: {
        _id: $_id
        title: $title
        price: $price
        stock: $stock
        createdAt: $createdAt
        shopMenu: $shopMenu
        priceFrom: $priceFrom
        stockFrom: $stockFrom
        createdAtFrom: $createdAtFrom
      }
      sort: { price: $priceSort, createdAt: $createdAtSort, stock: $stockSort }
    ) {
      _id
      title
      shopMenuName
      stock
      createdAt
      description
      price
      photoUrl
      attributes {
        attributeGroup {
          _id
          name
        }
        att {
          _id
          name
        }
      }
      promotion {
        percent
        discountFrom
        discountTo
      }
    }
  }
`;

const GET_PRODUCTS_COUNT = gql`
  query getProductsByShopAdminCount(
    $title: String
    $price: Float
    $stock: Int
    $createdAt: Date
    $shopMenu: String
    $priceFrom: Float
    $stockFrom: Int
    $createdAtFrom: Date
  ) {
    getProductsByShopAdminCount(
      filters: {
        title: $title
        price: $price
        createdAt: $createdAt
        stock: $stock
        shopMenu: $shopMenu
        priceFrom: $priceFrom
        stockFrom: $stockFrom
        createdAtFrom: $createdAtFrom
      }
    )
  }
`;

const GET_ATTRIBUTES = gql`
  query getAttributes($limit: Int, $skip: Int) {
    getAttributes(pagination: { limit: $limit, skip: $skip }) {
      _id
      name
    }
  }
`;

const DELETE_PRODUCT_BY_SHOP_ADMIN = gql`
  mutation removeProductByShopAdmin($idSet: [ID!]!) {
    removeProductByShopAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const GET_SHOP_BY_SHOP_ADMIN = gql`
  query getShopByShopAdmin {
    getShopByShopAdmin {
      _id
      rootCategory {
        _id
        title
      }
    }
  }
`;

const Products = (props) => {
  const perPageOptions = ["5", "10", "20"];
  const [perPage, setPerPage] = useState(10);

  const [pageCount, setPageCount] = useState(0);

  const orangeTheme = {
    checkboxColor: "orange",
    primaryColor: "warning",
    buttonColor: "orange",
  };
  const greenTheme = {
    checkboxColor: "#8bc34a",
    primaryColor: "success",
    buttonColor: "green",
  };
  const grayTheme = {
    checkboxColor: "#8bc34a",
    primaryColor: "yellow",
  };

  let theme = orangeTheme;
  if (props.theme === "Purchase") {
    theme = greenTheme;
  } else if (props.theme === "Restaurant") {
    theme = orangeTheme;
  } else if (props.theme === "superAdmin") {
    theme = grayTheme;
  }

  const [variables, setVariables] = useState({
    limit: perPage,
    skip: perPage * pageCount,
    _id: undefined,
    title: undefined,
    price: undefined,
    stock: undefined,
    stockSort: undefined,
    priceSort: undefined,
    createdAt: undefined,
    shopMenu: undefined,
    createdAtSort: -1,
    priceFrom: undefined,
    stockFrom: undefined,
    createdAtFrom: undefined,
  });

  const {
    loading: attributesLoading,
    error: attributesError,
    data: attributesData,
  } = useQuery(GET_ATTRIBUTES, {
    variables: {
      limit: 50,
      skip: 0,
    },
  });

  const [
    addProductViaExcel,
    {
      data: addProductViaExcelData,
      error: addProductViaExcelError,
      loading: addViaExcelLoading,
    },
  ] = useMutation(ADD_PRODUCTS_VIA_EXCEL);

  const [categoryText, setCategoryText] = useState("Submenu");

  const [disableMultiButton, setDisableMultiButton] = useState(false);
  const [idFilter, setIdFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [shopMenuFilter, setShopMenuFilter] = useState("");
  const [priceFilter, setPriceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [dateSort, setDateSort] = useState("down");
  const [stockFilter, setStockFilter] = useState("");
  const [stockSort, setStockSort] = useState("");
  const [priceSort, setPriceSort] = useState("");
  const [modal, setModal] = useState(false);
  const [productDetail, setProductDetail] = useState();
  const [dateFilterError, setDateFilterError] = useState("");

  const [priceFromFilter, setPriceFromFilter] = useState("");
  const [dateFromFilter, setDateFromFilter] = useState("");
  const [stockFromFilter, setStockFromFilter] = useState("");
  const [dateFromFilterError, setDateFromFilterError] = useState("");

  // Range selector states for price and stock
  const [priceRangeMin, setPriceRangeMin] = useState(0);
  const [priceRangeMax, setPriceRangeMax] = useState(0);
  const [selectedPriceMin, setSelectedPriceMin] = useState(0);
  const [selectedPriceMax, setSelectedPriceMax] = useState(0);

  const [stockRangeMin, setStockRangeMin] = useState(0);
  const [stockRangeMax, setStockRangeMax] = useState(0);
  const [selectedStockMin, setSelectedStockMin] = useState(0);
  const [selectedStockMax, setSelectedStockMax] = useState(0);

  const [checkAll, setCheckAll] = useState(false);
  const [isOldDesign, setIsOldDesign] = useState(false);
  const [idsForDelete, setIdsForDelete] = useState([]);
  const [deleteSomeModal, setDeleteSomeModal] = useState(false);

  const [deleteErrorModal, setDeleteErrorModal] = useState(false);
  const [deleteErrorText, setDeleteErrorText] = useState("");

  const [addErrorModal, setaddErrorModal] = useState(false);
  const [addErrorText, setaddErrorText] = useState("");
  const [noFilterModal, setNoFilterModal] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [productForDelete, setProductForDelete] = useState();

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
  });

  const {
    data: ShopData,
    loading: ShopLoading,
    error: ShopError,
  } = useQuery(GET_SHOP_BY_SHOP_ADMIN);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuId, setMenuId] = useState(null);

  const handleClick = (event, id) => {
    setMenuId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuId(null);
  };

  const [excelData, setExcelData] = useState([
    ["title", categoryText.toLowerCase(), "price", "stock", "date"],
  ]);

  useEffect(() => {
    if (ShopData && ShopData.getShopByShopAdmin.rootCategory) {
      if (ShopData.getShopByShopAdmin.rootCategory.title === "Restaurant") {
        setCategoryText("Submenu");
        setExcelData([["title", "submenu", "price", "stock", "date"]]);
      } else {
        setCategoryText("Category");
        setExcelData([["title", "category", "price", "stock", "date"]]);
      }
    }
  }, [, ShopData, ShopLoading]);

  const [
    getProductsByShopAdmin,
    { data: shopLazyData, loading: shopLazyLoading, error: shopLazyError },
  ] = useLazyQuery(GET_PRODUCTS);

  const [showExcelButton, setShowExcelButton] = useState("firstStatus");

  useEffect(() => {
    if (
      countData &&
      countData.getProductsByShopAdminCount > 0 &&
      excelData.length === countData.getProductsByShopAdminCount + 1
    ) {
      setShowExcelButton("done");
    }
  }, [excelData, countData, countLoading]);

  useEffect(() => {
    if (shopLazyData) {
      setExcelData([
        ...excelData,
        ...Array.from(shopLazyData.getProductsByShopAdmin, (item) => [
          item.title,
          item.shopMenuName,
          item.price.toFixed(2),
          item.stock,
          moment(item.createdAt).format("MM/DD/YYYY HH:mm"),
        ]),
      ]);
    }
  }, [, shopLazyData, shopLazyLoading]);

  const onExcelFinished = () => {
    let wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(wb, ws, "Trips");
    XLSX.writeFile(wb, "Products.xlsx");
  };

  const onDownloadData = () => {
    if (countData) {
      setShowExcelButton("downloading");
      getProductsByShopAdmin({
        variables: {
          ...variables,
          skip: 0,
          limit: countData.getProductsByShopAdminCount,
        },
      });
    }
  };

  const linkPage = (route) => {
    window.location.href = endPoint + `/shopAdmin/${route}`;
  };

  const [showMultipleAdd, setShowMultipleAdd] = useState(false);
  const [zipFile, setZipFile] = useState("");
  const [zipFileError, setZipFileError] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [importResultModal, setImportResultModal] = useState(false);
  const [importResultText, setImportResultText] = useState("");
  const [importResultSuccess, setImportResultSuccess] = useState(false);

  const arrayForTemplateExcel = [
    [
      "Title",
      "Price",
      "Stock",
      "Description",
      "Discount",
      "Discount percentage",
      "Discount start?",
      "Discount end?",
      "Parent",
      "Delivery vehicle",
    ],
    ["valid example1", 25, 2, "test description", "", "", "", "", "", "cars"],
    [
      "valid example2",
      25,
      2,
      "test description",
      "yes",
      10,
      "2021-11-25T11:00:00.000Z",
      "2021-11-27T11:00:00.000Z",
      "test1 category",
      "cars",
    ],
    [
      "valid example3",
      24,
      2,
      "test description",
      "-",
      "-",
      "-",
      "-",
      "",
      "truck_trailer",
    ],
    [
      "valid example4",
      25,
      2,
      "test description",
      "no",
      "-",
      "-",
      "-",
      "",
      "truck_trailer",
    ],
  ];

  const onDownloadTemplate = () => {
    let wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(arrayForTemplateExcel);
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "Spark-Products-Template.xlsx");
  };

  const uploadZipFile = (file) => {
    const uploadedFile = file.src.file;
    if (!uploadedFile) {
      setZipFileError(true);
      return;
    }

    const validZipType =
      uploadedFile.type === "application/zip" ||
      uploadedFile.type === "application/x-zip-compressed" ||
      uploadedFile.name.toLowerCase().endsWith(".zip");

    if (!validZipType) {
      setZipFile("");
      setZipFileError(true);
      return;
    }

    setZipFile(uploadedFile);
    setZipFileError(false);
  };

  const handleImportZip = () => {
    if (!zipFile) {
      setZipFileError(true);
      return;
    }
    onAddMultiple();
  };

  const onAddMultiple = () => {
    setDisableMultiButton(true);
    addProductViaExcel({
      variables: { zipFile: zipFile },
    })
      .then((res) => {
        setDisableMultiButton(false);
        setImportModalOpen(false);
        setImportResultSuccess(true);
        setImportResultText(
          res?.data?.addProductViaExcel?.message ||
            "Products imported successfully.",
        );
        setImportResultModal(true);
        if (refetch) {
          refetch();
        }
      })
      .catch((err) => {
        setDisableMultiButton(false);
        const message =
          err?.graphQLErrors?.[0]?.message ||
          err?.message ||
          "Import failed. Please try again.";
        setImportResultSuccess(false);
        setImportResultText(message);
        setImportResultModal(true);
      });
  };

  const onSelectProductDetail = (product) => {
    setModal(true);
    setProductDetail(product);
  };

  const onDeleteProduct = (product) => {
    setDeleteModal(true);
    setProductForDelete([product._id]);
  };

  const onDeleteSome = () => {
    setDeleteSomeModal(true);
  };

  const [removeProductByShopAdmin] = useMutation(DELETE_PRODUCT_BY_SHOP_ADMIN);

  const deleteProduct = () => {
    removeProductByShopAdmin({ variables: { idSet: productForDelete } })
      .then((res) => {
        setDeleteModal(false);
        refetch();
      })
      .catch((err) => {
        console.log(err);
        if (err.graphQLErrors && err.graphQLErrors.length > 0) {
          setDeleteModal(false);
          setDeleteErrorText(err.graphQLErrors[0].message);
          setDeleteErrorModal(true);
        }
      });
  };

  const deleteSome = () => {
    removeProductByShopAdmin({ variables: { idSet: idsForDelete } })
      .then((res) => {
        setDeleteSomeModal(false);
        setIdsForDelete([]);
        refetch();
      })
      .catch((err) => {
        console.log(err);
        if (err.graphQLErrors && err.graphQLErrors.length > 0) {
          setDeleteSomeModal(false);
          setIdsForDelete([]);
          setDeleteErrorText(err.graphQLErrors[0].message);
          setDeleteErrorModal(true);
        }
      });
  };

  const onPriceSortChange = () => {
    if (!priceSort) {
      setPriceSort("up");
    } else {
      if (priceSort === "up") {
        setPriceSort("down");
      } else {
        setPriceSort("");
      }
    }
  };

  const onDateSortChange = () => {
    if (!dateSort) {
      setDateSort("up");
    } else {
      if (dateSort === "up") {
        setDateSort("down");
      } else {
        setDateSort("");
      }
    }
  };

  const onStockSortChange = () => {
    if (!stockSort) {
      setStockSort("up");
    } else {
      if (stockSort === "up") {
        setStockSort("down");
      } else {
        setStockSort("");
      }
    }
  };

  useEffect(() => {
    if (!dateFromFilter) {
      setDateFromFilterError("");
    } else {
      if (
        moment(
          dateFromFilter,
          ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"],
          true,
        ).isValid()
      ) {
        setDateFromFilterError("");
      } else {
        setDateFromFilterError("invalid date");
      }
    }
  }, [dateFromFilter]);

  useEffect(() => {
    if (!dateFilter) {
      setDateFilterError("");
    } else {
      if (
        moment(
          dateFilter,
          ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"],
          true,
        ).isValid()
      ) {
        setDateFilterError("");
      } else {
        setDateFilterError("invalid date");
      }
    }
  }, [dateFilter]);

  useEffect(() => {
    if (dateSort) {
      if (dateSort === "up") {
        setVariables((variables) => ({ ...variables, createdAtSort: 1 }));
      } else if (dateSort === "down") {
        setVariables((variables) => ({ ...variables, createdAtSort: -1 }));
      }
    } else {
      setVariables((variables) => ({ ...variables, createdAtSort: undefined }));
    }
  }, [dateSort]);

  const { data, loading, error, refetch } = useQuery(GET_PRODUCTS, {
    variables,
    fetchPolicy: "network-only",
  });

  const {
    data: countData,
    error: countError,
    loading: countLoading,
  } = useQuery(GET_PRODUCTS_COUNT, {
    variables,
    fetchPolicy: "network-only",
  });

  const [
    getAllProducts,
    {
      data: allProductsData,
      loading: allProductsLoading,
      error: allProductsError,
    },
  ] = useLazyQuery(GET_PRODUCTS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (countData?.getProductsByShopAdminCount >= 0) {
      getAllProducts({
        variables: {
          ...variables,
          skip: 0,
          limit: countData.getProductsByShopAdminCount,
        },
      });
    }
  }, [variables, countData?.getProductsByShopAdminCount, getAllProducts]);

  if (countError) {
    console.log(countError);
  }

  // for pagination
  const onNextPage = () => {
    if (
      pageCount !== Math.ceil(effectiveCount / perPage) - 1 &&
      effectiveCount !== 0
    ) {
      setPageCount((pageCount) => pageCount + 1);
    }
  };
  const onPrevPage = () => {
    if (pageCount !== 0) {
      setPageCount((pageCount) => pageCount - 1);
    }
  };
  const onFirstPage = () => {
    setPageCount(0);
  };
  const onLastPage = () => {
    if (effectiveCount !== 0) {
      setPageCount(Math.ceil(effectiveCount / perPage) - 1);
    }
  };
  useEffect(() => {
    setVariables((variables) => ({ ...variables, skip: perPage * pageCount }));
  }, [pageCount]);

  useEffect(() => {
    setVariables((variables) => ({ ...variables, limit: perPage }));
  }, [perPage]);

  useEffect(() => {
    if (data) {
      setCheckAll(true);
      data.getProductsByShopAdmin.map((item) => {
        if (!idsForDelete.includes(item._id)) {
          setCheckAll(false);
        }
      });
    }
  }, [data, loading, idsForDelete, pageCount, perPage]);

  useEffect(() => {
    if (priceSort) {
      if (priceSort === "up") {
        setVariables((variables) => ({ ...variables, priceSort: 0 }));
      } else if (priceSort === "down") {
        setVariables((variables) => ({ ...variables, priceSort: -1 }));
      }
    } else {
      setVariables((variables) => ({ ...variables, priceSort: undefined }));
    }
  }, [priceSort]);

  useEffect(() => {
    if (stockSort) {
      if (stockSort === "up") {
        setVariables((variables) => ({ ...variables, stockSort: 1 }));
      } else if (stockSort === "down") {
        setVariables((variables) => ({ ...variables, stockSort: -1 }));
      }
    } else {
      setVariables((variables) => ({ ...variables, stockSort: undefined }));
    }
  }, [stockSort]);

  const onFilterSubmit = () => {
    let hasFilter =
      nameFilter ||
      variables.title ||
      stockFilter ||
      variables.stock ||
      dateFilter ||
      variables.createdAt ||
      priceFilter ||
      variables.price ||
      priceFromFilter ||
      variables.priceFrom ||
      dateFromFilter ||
      variables.createdAtFrom ||
      stockFromFilter ||
      variables.stockFrom ||
      shopMenuFilter ||
      variables.shopMenu;

    if (!hasFilter) {
      setNoFilterModal(true);
    } else {
      setPageCount(0);
      setExcelData((excelData) => [excelData[0]]);
      setShowExcelButton("firstStatus");

      if (nameFilter) {
        setVariables((variables) => ({
          ...variables,
          title: nameFilter.trim(),
        }));
      } else {
        setVariables((variables) => ({ ...variables, title: undefined }));
      }

      if (shopMenuFilter) {
        setVariables((variables) => ({
          ...variables,
          shopMenu: shopMenuFilter.trim(),
        }));
      } else {
        setVariables((variables) => ({ ...variables, shopMenu: undefined }));
      }

      if (
        dateFromFilter &&
        moment(
          dateFromFilter,
          ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"],
          true,
        ).isValid()
      ) {
        setVariables((variables) => ({
          ...variables,
          createdAtFrom: moment(dateFromFilter).format("YYYY-MM-DD"),
        }));
      } else {
        setVariables((variables) => ({
          ...variables,
          createdAtFrom: undefined,
        }));
      }

      if (
        dateFilter &&
        moment(
          dateFilter,
          ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"],
          true,
        ).isValid()
      ) {
        setVariables((variables) => ({
          ...variables,
          createdAt: moment(dateFilter).format("YYYY-MM-DD"),
        }));
        console.log(moment(dateFilter).format("YYYY-MM-DD"));
      } else {
        setVariables((variables) => ({ ...variables, createdAt: undefined }));
      }

      if (stockFromFilter) {
        setVariables((variables) => ({
          ...variables,
          stockFrom: parseFloat(stockFromFilter.trim()),
        }));
      } else {
        setVariables((variables) => ({ ...variables, stockFrom: undefined }));
      }

      if (stockFilter) {
        setVariables((variables) => ({
          ...variables,
          stock: parseFloat(stockFilter.trim()),
        }));
      } else {
        setVariables((variables) => ({ ...variables, stock: undefined }));
      }

      if (priceFromFilter) {
        setVariables((variables) => ({
          ...variables,
          priceFrom: parseFloat(priceFromFilter.trim()),
        }));
      } else {
        setVariables((variables) => ({ ...variables, priceFrom: undefined }));
      }

      if (priceFilter) {
        setVariables((variables) => ({
          ...variables,
          price: parseFloat(priceFilter.trim()),
        }));
      } else {
        setVariables((variables) => ({ ...variables, price: undefined }));
      }
    }
  };

  const onClearFilters = () => {
    setExcelData((excelData) => [excelData[0]]);
    setShowExcelButton("firstStatus");
    setVariables({
      limit: perPage,
      skip: perPage * pageCount,
      _id: undefined,
      title: undefined,
      price: undefined,
      stock: undefined,
      stockSort: undefined,
      priceSort: undefined,
      createdAt: undefined,
      shopMenu: undefined,
      createdAtSort: -1,
      priceFrom: undefined,
      stockFrom: undefined,
      createdAtFrom: undefined,
    });
    setNameFilter("");
    setShopMenuFilter("");
    setStatusFilter("");
    setPriceFilter("");
    setPriceSort("");
    setDateFilter("");
    setStockFilter("");
    setDateSort("down");
    setStockSort("");
    setPriceFromFilter("");
    setStockFromFilter("");
    setDateFromFilter("");
  };

  const handleEnter = (e) => {
    if (e.charCode === 13) {
      onFilterSubmit();
    }
  };

  // calculate total price
  const [total, setTotal] = useState(0);
  useEffect(() => {
    if (data) {
      let number = 0;
      data.getProductsByShopAdmin.map((item) => {
        number = number + item.price;
      });
      setTotal(number);
    }
  }, [data, loading]);

  // compute price/stock ranges when products load
  useEffect(() => {
    if (currentProducts && currentProducts.length > 0) {
      const prices = currentProducts.map((p) =>
        typeof p.price === "number" ? p.price : 0,
      );
      const stocks = currentProducts.map((p) =>
        typeof p.stock === "number" ? p.stock : 0,
      );
      const minP = Math.min(...prices);
      const maxP = Math.max(...prices);
      const minS = Math.min(...stocks);
      const maxS = Math.max(...stocks);
      setPriceRangeMin(minP);
      setPriceRangeMax(maxP);
      setSelectedPriceMin(minP);
      setSelectedPriceMax(maxP);

      setStockRangeMin(minS);
      setStockRangeMax(maxS);
      setSelectedStockMin(minS);
      setSelectedStockMax(maxS);
    }
  }, [currentProducts]);

  // computed percents for visual range fills (avoid divide by zero)
  const priceRangeDelta = priceRangeMax - priceRangeMin || 1;
  const pricePercMin =
    ((selectedPriceMin - priceRangeMin) / priceRangeDelta) * 100;
  const pricePercMax =
    ((selectedPriceMax - priceRangeMin) / priceRangeDelta) * 100;

  const stockRangeDelta = stockRangeMax - stockRangeMin || 1;
  const stockPercMin =
    ((selectedStockMin - stockRangeMin) / stockRangeDelta) * 100;
  const stockPercMax =
    ((selectedStockMax - stockRangeMin) / stockRangeDelta) * 100;

  // helpers for slider percentages and formatted values
  const priceRangeSpan = Math.max(priceRangeMax - priceRangeMin, 1);
  const priceLeftPercent = Math.round(
    ((selectedPriceMin - priceRangeMin) / priceRangeSpan) * 100,
  );
  const priceRightPercent = Math.round(
    ((selectedPriceMax - priceRangeMin) / priceRangeSpan) * 100,
  );

  const stockRangeSpan = Math.max(stockRangeMax - stockRangeMin, 1);
  const stockLeftPercent = Math.round(
    ((selectedStockMin - stockRangeMin) / stockRangeSpan) * 100,
  );
  const stockRightPercent = Math.round(
    ((selectedStockMax - stockRangeMin) / stockRangeSpan) * 100,
  );

  const formatMoney = (v) => {
    if (typeof v !== "number") return "-";
    try {
      return v.toLocaleString();
    } catch (e) {
      return String(v);
    }
  };

  const currentProducts = data?.getProductsByShopAdmin || [];
  const allProducts = allProductsData?.getProductsByShopAdmin || [];
  // derive unique categories from loaded products
  const categories = Array.from(
    new Set(currentProducts.map((item) => item.shopMenuName).filter(Boolean)),
  );

  const applyFilters = (products) => {
    return products.filter((p) => {
      const nameMatch = nameFilter
        ? p.title
          ? p.title.toLowerCase().includes(nameFilter.toLowerCase())
          : false
        : true;
      const categoryMatch = shopMenuFilter
        ? (p.shopMenuName || "") === shopMenuFilter
        : true;
      const productStatus =
        p.stock <= 0 ? "out" : p.stock <= 5 ? "low" : "active";
      const statusMatch = statusFilter ? productStatus === statusFilter : true;

      const minPrice = priceFromFilter ? parseFloat(priceFromFilter) : null;
      const maxPrice = priceFilter ? parseFloat(priceFilter) : null;
      const priceMatch =
        typeof p.price === "number"
          ? (minPrice === null || p.price >= minPrice) &&
            (maxPrice === null || p.price <= maxPrice)
          : true;

      const minStock = stockFromFilter ? parseFloat(stockFromFilter) : null;
      const maxStock = stockFilter ? parseFloat(stockFilter) : null;
      const stockMatch =
        typeof p.stock === "number"
          ? (minStock === null || p.stock >= minStock) &&
            (maxStock === null || p.stock <= maxStock)
          : true;

      const fromDate =
        dateFromFilter &&
        moment(
          dateFromFilter,
          ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"],
          true,
        );
      const toDate =
        dateFilter &&
        moment(dateFilter, ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"], true);
      const createdAt = p.createdAt ? moment(p.createdAt) : null;
      const dateMatch =
        (!fromDate ||
          !fromDate.isValid() ||
          (createdAt && createdAt.isSameOrAfter(fromDate, "day"))) &&
        (!toDate ||
          !toDate.isValid() ||
          (createdAt && createdAt.isSameOrBefore(toDate, "day")));

      return (
        nameMatch &&
        categoryMatch &&
        statusMatch &&
        priceMatch &&
        stockMatch &&
        dateMatch
      );
    });
  };

  const [sortOption, setSortOption] = useState("");

  const sortProducts = (arr, option) => {
    if (!Array.isArray(arr)) return [];
    const copy = [...arr];
    switch (option) {
      case "category_asc":
        return copy.sort((a, b) =>
          (a.shopMenuName || "").localeCompare(b.shopMenuName || ""),
        );
      case "category_desc":
        return copy.sort((a, b) =>
          (b.shopMenuName || "").localeCompare(a.shopMenuName || ""),
        );
      case "title_asc":
        return copy.sort((a, b) =>
          (a.title || "").localeCompare(b.title || ""),
        );
      case "title_desc":
        return copy.sort((a, b) =>
          (b.title || "").localeCompare(a.title || ""),
        );
      case "price_desc":
        return copy.sort((a, b) => (b.price || 0) - (a.price || 0));
      case "price_asc":
        return copy.sort((a, b) => (a.price || 0) - (b.price || 0));
      case "stock_desc":
        return copy.sort((a, b) => (b.stock || 0) - (a.stock || 0));
      case "stock_asc":
        return copy.sort((a, b) => (a.stock || 0) - (b.stock || 0));
      case "date_asc":
        return copy.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        );
      case "date_desc":
        return copy.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
      default:
        return copy;
    }
  };

  const toggleHeaderSort = (field) => {
    // map field to sortOption keys
    const map = {
      title: "title",
      category: "category",
      price: "price",
      stock: "stock",
      date: "date",
    };
    const key = map[field] || field;
    const desc = `${key}_desc`;
    const asc = `${key}_asc`;
    setPageCount(0);
    setSortOption((cur) => (cur === desc ? asc : desc));
  };

  // Sort the full dataset client-side when a sort is chosen
  const sortedAllProducts = sortProducts(allProducts || [], sortOption);
  const filteredAllProducts = applyFilters(sortedAllProducts);
  const filteredProducts = applyFilters(currentProducts);

  // Declared before sourceProducts on purpose: it is read there, and Babel turns
  // these consts into vars, so a later declaration would silently read undefined
  // instead of throwing, and every filter would be ignored when picking a source.
  const hasActiveFilters = Boolean(
    nameFilter ||
    shopMenuFilter ||
    statusFilter ||
    priceFromFilter ||
    priceFilter ||
    stockFromFilter ||
    stockFilter ||
    dateFromFilter ||
    dateFilter,
  );

  // derive the currently visible products (apply pagination to the active source)
  const sourceProducts = hasActiveFilters
    ? filteredAllProducts
    : sortOption
      ? sortedAllProducts
      : filteredProducts;

  // filteredAllProducts and sortedAllProducts hold the whole dataset, so they are
  // paginated here. filteredProducts comes from the paginated server query and is
  // already only the current page, so slicing it again would empty every page
  // after the first (page 2 would slice [10..20] out of the 2 rows it received).
  const usesClientPagination = hasActiveFilters || Boolean(sortOption);

  const currentPageProducts = !Array.isArray(sourceProducts)
    ? []
    : usesClientPagination
      ? sourceProducts.slice(pageCount * perPage, (pageCount + 1) * perPage)
      : sourceProducts;

  // selection state for the current view (used for tri-state checkboxes)
  const selectedInCurrent = currentPageProducts.filter((p) =>
    idsForDelete.includes(p._id),
  ).length;
  const totalInCurrent = currentPageProducts.length;
  const checkboxState =
    totalInCurrent === 0
      ? "unchecked"
      : selectedInCurrent === 0
        ? "unchecked"
        : selectedInCurrent === totalInCurrent
          ? "checked"
          : "indeterminate";

  const handleTableTopCheckboxChange = () => {
    if (checkboxState === "checked") {
      // remove current page ids from selection
      setIdsForDelete((ids) =>
        ids.filter((id) => !currentPageProducts.some((p) => p._id === id)),
      );
    } else {
      // add all current page ids to selection (avoid duplicates)
      setIdsForDelete((ids) => {
        const add = currentPageProducts.map((p) => p._id);
        const merged = Array.from(new Set([...(ids || []), ...add]));
        return merged;
      });
    }
  };

  const totalProductsCount = countData?.getProductsByShopAdminCount || 0;
  const effectiveCount = hasActiveFilters
    ? filteredAllProducts.length
    : sortOption
      ? sortedAllProducts.length
      : totalProductsCount;

  const lowStockCount = allProducts.filter(
    (item) => item.stock > 0 && item.stock <= 5,
  ).length;
  const outOfStockCount = allProducts.filter((item) => item.stock <= 0).length;
  const categoriesCount = new Set(
    allProducts.map((item) => item.shopMenuName).filter(Boolean),
  ).size;

  if (loading)
    return (
      <div style={{ textAlign: "center", marginTop: "200px" }}>
        <BeatLoader
          css={css`
            display: block;
            margin: 0 auto;
            border-color: red;
          `}
          size={15}
          margin={2}
          color={"gray"}
          loading={true}
        />
      </div>
    );
  if (error) {
    console.log(error);
    return <ErrorPage />;
  }

  return (
    <div style={{ position: "relative" }}>
      {/* <div style={{ position: "absolute", top: 8, left: 8, zIndex: 1000 }}>
        <div
          style={{
            display: "inline-flex",
            borderRadius: 6,
            overflow: "hidden",
            border: "1px solid #ccc",
          }}
        >
          <button
            style={{
              padding: "6px 10px",
              background: !isOldDesign ? "#2563eb" : "#fff",
              color: !isOldDesign ? "#fff" : "#000",
              border: "none",
            }}
            onClick={() => setIsOldDesign(false)}
            aria-pressed={!isOldDesign}
            title="New design"
          >
            New
          </button>
          <button
            style={{
              padding: "6px 10px",
              background: isOldDesign ? "#2563eb" : "#fff",
              color: isOldDesign ? "#fff" : "#000",
              border: "none",
            }}
            onClick={() => setIsOldDesign(true)}
            aria-pressed={isOldDesign}
            title="Old design"
          >
            Old
          </button>
        </div>
      </div> */}
      <div className="page productsPage">
        {/* MAIN */}
        <main className="main">
          {/* HEADER */}
          <header className="header">
            <div className="headerActions">
              <PageActionButton
                icon={
                  showExcelButton === "downloading" ? (
                    <MoonLoader size={14} color="#2563eb" loading={true} />
                  ) : (
                    <CloudDownloadIcon fontSize="small" />
                  )
                }
                label={
                  showExcelButton === "downloading"
                    ? "Exporting"
                    : showExcelButton === "done"
                      ? "Download Excel"
                      : "Export"
                }
                info={
                  showExcelButton === "downloading"
                    ? "Preparing file"
                    : showExcelButton === "done"
                      ? "Ready to download"
                      : "Excel"
                }
                onClick={() => {
                  if (showExcelButton === "done") {
                    onExcelFinished();
                  } else {
                    onDownloadData();
                  }
                }}
                loading={showExcelButton === "downloading"}
                disabled={showExcelButton === "downloading"}
              />
              <PageActionButton
                icon={<AddIcon fontSize="small" />}
                label={`Add ${props.theme === "Restaurant" ? "Food" : "Product"}`}
                info={`Create a new ${props.theme === "Restaurant" ? "food" : "product"}`}
                onClick={() =>
                  linkPage(
                    props.theme === "Restaurant" ? "addFood" : "addProduct",
                  )
                }
              />
              <PageActionButton
                icon={<CloudUploadIcon fontSize="small" />}
                label="Import"
                info={`${props.theme === "Restaurant" ? "Foods" : "Products"} by excel file`}
                onClick={() => setImportModalOpen(true)}
              />
            </div>
          </header>

          {/* STATS */}
          <section className="stats">
            <MetricCard
              icon={<StorefrontIcon />}
              title="Total Products"
              value={totalProductsCount}
            />
            <MetricCard
              icon={<Warning />}
              title="Low Stock"
              value={lowStockCount}
              tone="warning"
            />
            <MetricCard
              icon={<ArchiveIcon />}
              title="Out of Stock"
              value={outOfStockCount}
            />
            <MetricCard
              icon={<BuildIcon />}
              title="Categories"
              value={categoriesCount}
            />
          </section>

          {/* FILTER BAR */}
          <section className="filters">
            <SearchField
              placeholder="Search products by name..."
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
            />

            <div className="filtersSelects">
              <FilterDropdown
                label={categoryText}
                options={[
                  { value: "", label: `All ${categoryText.toLowerCase()}s` },
                  ...categories.map((c) => ({ value: c, label: c })),
                ]}
                value={shopMenuFilter}
                onChange={(e) => setShopMenuFilter(e.target.value)}
              />
              <FilterDropdown
                label="Status"
                options={[
                  { value: "", label: "All status" },
                  { value: "active", label: "Active" },
                  { value: "low", label: "Low Stock" },
                  { value: "out", label: "Out of Stock" },
                ]}
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              />
              <DateRangeFilter
                label="Created At"
                fromValue={dateFromFilter}
                toValue={dateFilter}
                onFromChange={(e) => setDateFromFilter(e.target.value)}
                onToChange={(e) => setDateFilter(e.target.value)}
              />
              <NumberRangeFilter
                label="Price"
                fromValue={priceFromFilter}
                toValue={priceFilter}
                onFromChange={(e) => setPriceFromFilter(e.target.value)}
                onToChange={(e) => setPriceFilter(e.target.value)}
              />
              <NumberRangeFilter
                label="Stock"
                fromValue={stockFromFilter}
                toValue={stockFilter}
                onFromChange={(e) => setStockFromFilter(e.target.value)}
                onToChange={(e) => setStockFilter(e.target.value)}
              />
            </div>
          </section>

          {/* ACTIVE FILTERS */}
          {hasActiveFilters && (
            <ActiveFilterChipList
              filters={[
                nameFilter && { id: "name", label: `Name: ${nameFilter}` },
                shopMenuFilter && {
                  id: "category",
                  label: `${categoryText}: ${shopMenuFilter}`,
                },
                statusFilter && {
                  id: "status",
                  label: `Status: ${statusFilter === "active" ? "Active" : statusFilter === "low" ? "Low Stock" : "Out of Stock"}`,
                },
                (priceFromFilter || priceFilter) && {
                  id: "price",
                  label: `Price: ${priceFromFilter || "-"} - ${priceFilter || "-"}`,
                },
                (stockFromFilter || stockFilter) && {
                  id: "stock",
                  label: `Stock: ${stockFromFilter || "-"} - ${stockFilter || "-"}`,
                },
                (dateFromFilter || dateFilter) && {
                  id: "date",
                  label: `Created At: ${dateFromFilter || "-"} - ${dateFilter || "-"}`,
                },
              ].filter(Boolean)}
              onClearFilter={(id) => {
                switch (id) {
                  case "name":
                    setNameFilter("");
                    break;
                  case "category":
                    setShopMenuFilter("");
                    break;
                  case "status":
                    setStatusFilter("");
                    break;
                  case "price":
                    setPriceFromFilter("");
                    setPriceFilter("");
                    break;
                  case "stock":
                    setStockFromFilter("");
                    setStockFilter("");
                    break;
                  case "date":
                    setDateFromFilter("");
                    setDateFilter("");
                    break;
                  default:
                    break;
                }
              }}
              onClearAll={onClearFilters}
            />
          )}

          {/* TABLE TOP */}
          <div className="tableTopBar">
            <div className="tableTopBarLeft">
              <div className="tableTopSelection">
                <Checkbox
                  size="small"
                  checked={checkboxState === "checked"}
                  indeterminate={checkboxState === "indeterminate"}
                  onChange={handleTableTopCheckboxChange}
                />
                <span>{idsForDelete.length} selected</span>
              </div>
              {idsForDelete.length > 0 && (
                <div className="hoverField">
                  <label className="rangeLabel">Bulk Actions</label>
                  <div className="hoverControl">
                    <ul className="dropdownList" role="listbox">
                      <li
                        className="dropdownItem"
                        onClick={() => {
                          if (idsForDelete.length > 0) {
                            onDeleteSome();
                          }
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <div className="tableTopBarRight">
              <div className="hoverField right" style={{ marginLeft: 8 }}>
                <label className="rangeLabel">
                  <SortIcon fontSize="small" />
                </label>
                <div className="hoverControl">
                  <ul className="dropdownList" role="listbox">
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("title_asc");
                        setPageCount(0);
                      }}
                    >
                      A-Z
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("title_desc");
                        setPageCount(0);
                      }}
                    >
                      Z-A
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("price_desc");
                        setPageCount(0);
                      }}
                    >
                      Highest price to lowest price
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("price_asc");
                        setPageCount(0);
                      }}
                    >
                      Lowest price to highest price
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("stock_desc");
                        setPageCount(0);
                      }}
                    >
                      Highest stock to lowest stock
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("stock_asc");
                        setPageCount(0);
                      }}
                    >
                      Lowest stock to highest stock
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("date_asc");
                        setPageCount(0);
                      }}
                    >
                      Oldest to Newest
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("date_desc");
                        setPageCount(0);
                      }}
                    >
                      Newest to oldest
                    </li>
                    <li
                      className="dropdownItem"
                      onClick={() => {
                        setSortOption("");
                        setPageCount(0);
                      }}
                    >
                      Clear sort
                    </li>
                  </ul>
                </div>
              </div>
              <IconButton
                className="tableTopIconButton"
                size="small"
                onClick={() => refetch()}
                title="Refresh products"
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            </div>
          </div>

          {/* TABLE */}
          <div className="tableResponsive">
            <section className="table">
              <div className="tableHeader">
                <div className="tableHeaderCell tableHeaderCheckbox">
                  <Checkbox
                    size="small"
                    checked={checkboxState === "checked"}
                    indeterminate={checkboxState === "indeterminate"}
                    onChange={handleTableTopCheckboxChange}
                  />
                </div>
                <div className="tableHeaderCell">
                  <div
                    className="tableHeaderLabel"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleHeaderSort("title")}
                  >
                    Product
                  </div>
                </div>
                <div className="tableHeaderCell">
                  <div
                    className="tableHeaderLabel"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleHeaderSort("category")}
                  >
                    Category
                    <SortIcon className="tableHeaderSort" />
                  </div>
                </div>
                <div className="tableHeaderCell">
                  <div
                    className="tableHeaderLabel"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleHeaderSort("price")}
                  >
                    Price
                    <SortIcon className="tableHeaderSort" />
                  </div>
                </div>
                <div className="tableHeaderCell">
                  <div
                    className="tableHeaderLabel"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleHeaderSort("stock")}
                  >
                    Stock
                    <SortIcon className="tableHeaderSort" />
                  </div>
                </div>
                <div className="tableHeaderCell">
                  <div className="tableHeaderLabel">
                    Status
                    <SortIcon className="tableHeaderSort" />
                  </div>
                </div>
                <div className="tableHeaderCell">
                  <div
                    className="tableHeaderLabel"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleHeaderSort("date")}
                  >
                    Created At
                    <SortIcon className="tableHeaderSort" />
                  </div>
                </div>
                <div className="tableHeaderCell tableHeaderAction">
                  Actions
                </div>
              </div>

              {currentPageProducts.length == 0 ? (
                <EmptyState message="No products found." />
              ) : (
                currentPageProducts.map((product) => {
                  const stockStatus =
                    product.stock <= 0
                      ? "out"
                      : product.stock <= 5
                        ? "low"
                        : "active";
                  const statusLabel =
                    product.stock <= 0
                      ? "Out of Stock"
                      : product.stock <= 5
                        ? "Low Stock"
                        : "Active";
                  const updatedDate = moment(product.createdAt).format(
                    "MMM D, YYYY",
                  );
                  const updatedTime = moment(product.createdAt).format(
                    "hh:mm A",
                  );
                  const imageUrl =
                    product.photoUrl && product.photoUrl.length > 0
                      ? `${graphqlUrl}${product.photoUrl[0]}`
                      : null;

                  return (
                    <div className="row" key={product._id}>
                      <Checkbox
                        size="small"
                        checked={idsForDelete.includes(product._id)}
                        onChange={() => {
                          if (idsForDelete.includes(product._id)) {
                            setIdsForDelete((ids) =>
                              ids.filter((id) => id !== product._id),
                            );
                          } else {
                            setIdsForDelete((ids) => [...ids, product._id]);
                          }
                        }}
                      />

                      <div className="product">
                        <div className="img">
                          {imageUrl ? (
                            <img src={imageUrl} alt={product.title} />
                          ) : (
                            <StorefrontIcon fontSize="small" />
                          )}
                        </div>
                        <div className="productInfo">
                          <h4>{product.title}</h4>
                          <p>
                            {product.description ||
                              product.shopMenuName ||
                              "No description"}
                          </p>
                        </div>
                      </div>

                      <span className="cellValue" data-label="Category">
                        {product.shopMenuName || "-"}
                      </span>
                      <span className="cellValue" data-label="Price">
                        {typeof product.price === "number"
                          ? `$${product.price.toFixed(2)}`
                          : "-"}
                      </span>
                      <span className="cellValue" data-label="Stock">
                        {product.stock ?? "-"}
                      </span>
                      <span data-label="Status">
                        <StatusBadge status={stockStatus} />
                      </span>
                      <span className="updated" data-label="Created At">
                        <strong>{updatedDate}</strong>
                        <span>{updatedTime}</span>
                      </span>

                      <div className="actions">
                        <IconButton
                          size="small"
                          className="rowActionButton"
                          onClick={() => {
                            if (props.theme === "Restaurant") {
                              window.location.href = `${endPoint}/shopAdmin/editFood/${product._id}`;
                            } else {
                              window.location.href = `${endPoint}/shopAdmin/editProduct/${product._id}`;
                            }
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          className="rowActionButton"
                          onClick={() => onDeleteProduct(product)}
                          title="Delete product"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        {/* <IconButton
                        size="small"
                        className="rowActionButton"
                        onClick={(e) => handleClick(e, product._id)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton> */}
                      </div>
                    </div>
                  );
                })
              )}
            </section>
          </div>

          {/* PAGINATION */}
          <PaginationComponent
            currentPage={pageCount}
            totalPages={Math.ceil(effectiveCount / perPage)}
            pageSize={perPage}
            totalItems={effectiveCount}
            itemsStart={Math.min(pageCount * perPage + 1, effectiveCount)}
            itemsEnd={Math.min((pageCount + 1) * perPage, effectiveCount)}
            onPageChange={(newPage) => setPageCount(newPage)}
            onPageSizeChange={(newSize) => {
              setPerPage(parseInt(newSize));
              setPageCount(0);
            }}
            pageSizeOptions={perPageOptions}
            onPrevPage={onPrevPage}
            onNextPage={onNextPage}
            hasActiveFilters={hasActiveFilters}
            filteredCount={filteredAllProducts.length}
          />
        </main>

        <DialogShell
          open={importModalOpen}
          onClose={() => setImportModalOpen(false)}
          title="Import products"
          subtitle="Paste your import content below and submit when ready."
        >
          <div className="importAlertBox">
            Upload a zip file containing an Excel file like the template and
            photos named as [product row number]-[photo number].
          </div>

          <button
            type="button"
            onClick={onDownloadTemplate}
            className="importTemplateButton"
          >
            Download template
          </button>

          <div
            className="importDropZone"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const file = e.dataTransfer.files[0];
              if (file) {
                uploadZipFile({ src: { file } });
                setZipFileError(false);
              }
            }}
          >
            <div className="importDropZoneTitle">
              Drag & drop a zip file here
            </div>
            <div className="importDropZoneHint">
              Or click to select a .zip file
            </div>
            <input
              type="file"
              accept="application/zip,application/x-zip-compressed"
              style={{ display: "none" }}
              id="import-zip-upload"
              onChange={(e) => {
                const file = e.target.files && e.target.files[0];
                if (file) {
                  uploadZipFile({ src: { file } });
                  setZipFileError(false);
                }
              }}
            />
            <label htmlFor="import-zip-upload" className="importChooseButton">
              Choose zip file
            </label>
            {zipFile && (
              <div className="importSelectedFile">
                Selected file: {zipFile.name}
              </div>
            )}
            {zipFileError && (
              <div className="importErrorText">
                Please upload a valid zip file.
              </div>
            )}
          </div>

          <div className="importActions">
            <button
              type="button"
              onClick={() => {
                setImportModalOpen(false);
                setZipFile("");
              }}
              disabled={disableMultiButton}
              className="importCancelButton"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                handleImportZip();
              }}
              disabled={disableMultiButton}
              className={`importSubmitButton ${disableMultiButton ? "loading" : ""}`}
            >
              {disableMultiButton ? (
                <MoonLoader size={14} color="#ffffff" loading={true} />
              ) : null}
              {disableMultiButton ? "Importing..." : "Import"}
            </button>
          </div>
        </DialogShell>

        <DialogShell
          open={importResultModal}
          onClose={() => setImportResultModal(false)}
          title={importResultSuccess ? "Import completed" : "Import failed"}
          type={importResultSuccess ? "success" : "error"}
        >
          <div
            className={`resultDialogMessage ${importResultSuccess ? "success" : "error"}`}
          >
            {importResultText}
          </div>
          <div className="resultDialogActions">
            <button
              type="button"
              onClick={() => setImportResultModal(false)}
              className={`resultDialogButton ${importResultSuccess ? "success" : "error"}`}
            >
              Close
            </button>
          </div>
        </DialogShell>

        <DialogShell
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          title="Delete product?"
          type="error"
        >
          <div className="resultDialogMessage error">
            This action cannot be undone. Are you sure you want to delete this
            product?
          </div>
          <div className="resultDialogActions">
            <button
              type="button"
              onClick={() => setDeleteModal(false)}
              className="resultDialogButton"
              style={{ backgroundColor: "#e2e8f0", color: "#000" }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => deleteProduct()}
              className="resultDialogButton error"
            >
              Delete
            </button>
          </div>
        </DialogShell>

        <DialogShell
          open={deleteSomeModal}
          onClose={() => {
            setDeleteSomeModal(false);
            setIdsForDelete([]);
          }}
          title={`Delete ${idsForDelete.length} product${idsForDelete.length !== 1 ? "s" : ""}?`}
          type="error"
        >
          <div className="resultDialogMessage error">
            This action cannot be undone. Are you sure you want to delete{" "}
            {idsForDelete.length} product
            {idsForDelete.length !== 1 ? "s" : ""}?
          </div>
          <div className="resultDialogActions">
            <button
              type="button"
              onClick={() => {
                setDeleteSomeModal(false);
                setIdsForDelete([]);
              }}
              className="resultDialogButton"
              style={{ backgroundColor: "#e2e8f0", color: "#000" }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => deleteSome()}
              className="resultDialogButton error"
            >
              Delete
            </button>
          </div>
        </DialogShell>
      </div>
    </div>
  );
};

export default Products;
